import { Fragment } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import cnames from 'classnames'
import { buildReservationKey } from 'Utils/reservation'
import { routesHandler } from 'Checkout/Routes/routesHandler'
import { withSkeleton } from 'Shared/Skeleton/withSkeleton'
import Reservation from 'Checkout/Components/Shared/CartSummary/Reservation'

const Reservations = ({ isCollapseOpen, reservations, reservationWrapperClasses }) => {
  const { pathname } = useLocation()
  const reservationsToShow = reservations || useSelector(state => state.cart.pricing.data.reservations)
  const isLoading = useSelector(state => state.cart.pricing.loading)
  const className = cnames('reservations', { 'skeleton-loading': isLoading })

  if (pathname === routesHandler.cart.path || !reservationsToShow?.length) return

  return (
    <div className={className}>
      {reservationsToShow.map((reservation, index) => (
        <Fragment key={buildReservationKey(index, reservation)}>
          <Reservation isCollapseOpen={isCollapseOpen} reservation={reservation}
                       wrapperClasses={reservationWrapperClasses} />

          <hr />
        </Fragment>
      ))}
    </div>
  )
}

Reservations.defaultProps = {
  isCollapseOpen: false,
}

Reservations.propTypes = {
  isCollapseOpen: PropTypes.bool,
}

export default withSkeleton(Reservations, state => state.cart.pricing, { hideError: true })
